/*
This file is autogenerated. Don't change it directly.
Instead, change the "addons" setting in your package.json file.
*/

const projectConfigLoader = require('@root/config');
import kitconceptvoltoBlocksGrid from '@kitconcept/volto-blocks-grid';

const addonsInfo = [{"name":"@kitconcept/volto-blocks-grid","version":"3.1.0","isPublishedPackage":true,"isRegisteredAddon":true,"modulePath":"/opt/atlassian/pipelines/agent/build/node_modules/@kitconcept/volto-blocks-grid/src","packageJson":"/opt/atlassian/pipelines/agent/build/node_modules/@kitconcept/volto-blocks-grid/package.json","addons":[]}];
export { addonsInfo };

const safeWrapper = (func) => (config) => {
  const res = func(config);
  if (typeof res === 'undefined') {
    throw new Error("Configuration function doesn't return config");
  }
  return res;
}

const projectConfig = (config) => {
  return typeof projectConfigLoader.default === "function" ? projectConfigLoader.default(config) : config;
}

const load = (config) => {
  const addonLoaders = [kitconceptvoltoBlocksGrid];
  if(!addonLoaders.every((el) => typeof el === "function")) {
    throw new TypeError(
      'Each addon has to provide a function applying its configuration to the projects configuration.',
    );
  }
  return projectConfig(addonLoaders.reduce((acc, apply) => safeWrapper(apply)(acc), config));
};
export default load;
